module.exports = __webpack_public_path__ + "img/yyzsyr.0db420a7.png";